
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/studio/design-system",
      function () {
        return require("private-next-pages/services/studio/design-system.tsx");
      }
    ]);
  